import { render, staticRenderFns } from "./business_exploration_trip.vue?vue&type=template&id=2320bb02&"
import script from "./business_exploration_trip.vue?vue&type=script&lang=js&"
export * from "./business_exploration_trip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports